export const DOCTOR_DETAIL_BACK = 'DOCTOR_DETAIL_BACK';
export const DOCTOR_DETAIL_BUTTON = 'DOCTOR_DETAIL_BUTTON';
